import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL, NGROK_URL } from "../../utils/const";



const formSchema = {
  under16: {
    fields: [
      {
        type: "radio",
        name: "under16",
        label: "Are you under 16 years of age? *",
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  cssOrPss: {
    condition: (formData) => formData.under16 !== "",
    fields: [
      {
        type: "radio",
        name: "cssOrPss",
        label: (formData) =>
          `Are you or ${
            formData.under16 === "yes"
              ? "either of your parents:"
              : "your spouse: "
          }`,
        subLabel: [
          "an eligible employee in the CSS (Commonwealth Service Superannuation) scheme, or",
          "a member of the PSS(Opens help) (Public Sector Superannuation) scheme?",
        ],
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  isAuResident: {
    condition: (formData) => formData.cssOrPss === "no",
    fields: [
      {
        label:
          "Are / were you an Australian resident for tax purposes immediately before leaving Australia? *",
        required: true,
        type: "radio",
        name: "isAuResident",
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  isTemporaryResident: {
    condition: (formData) => formData.isAuResident === "yes",
    fields: [
      {
        type: "radio",
        name: "isTemporaryResident",
        label:
          "Are you a temporary Australian resident Link opens in new window leaving Australia to live in another country? *",
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  isEmigrating: {
    condition: (formData) => formData.isTemporaryResident === "no",
    fields: [
      {
        type: "radio",
        name: "isEmigrating",
        label:
          "Are you an Australian resident who is emigrating to live permanently in another country? *",
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  birthCountry: {
    condition: (formData) => formData.isEmigrating === "no",
    fields: [
      {
        type: "radio",
        name: "birthCountry",
        label: "Where were you born? *",
        required: true,
        options: [
          { value: "australia", label: "Australia" },
          { value: "other", label: "Another Country" },
        ],
      },
    ],
  },
  homeCountry: {
    condition: (formData) => formData.birthCountry !== "",
    fields: [
      {
        type: "radio",
        name: "homeCountry",
        label: "What do you consider to be your home country? *",
        required: true,
        options: [
          { value: "australia", label: "Australia" },
          { value: "other", label: "Another Country" },
          { value: "none", label: "Don't have a home country" },
        ],
      },
    ],
  },
  whyAllowedInAustralia: {
  condition: (formData) => (formData.birthCountry === "other" && formData.homeCountry!=="")||(formData.birthCountry === "australia" && (formData.homeCountry==="other"|| formData.homeCountry==="none")),
  fields: [
    {
      type: "radio",
      name: "whyAllowedInAustralia",
      label: "Why were you allowed to be in Australia? *",
      required: true,
      options: [
        { value: "citizenship", label: "Citizenship" },
        { value: "permanentResidency", label: "Permanent residency" },
        { value: "visaUnlimited", label: "Visa - unlimited stay" },
        { value: "visaLimited", label: "Visa - limited stay" },
        { value: "notAuthorised", label: "Not authorised" }
      ],
    },
  ],
},
  durationBeforeReturningToAu: {
    condition: (formData) => ['visaUnlimited', 'visaLimited', 'notAuthorised'].includes(formData.whyAllowedInAustralia),
    fields: [
    {
      type: "radio",
      name: "durationBeforeReturningToAu",
      label: "How long do you intend to remain overseas before visiting or returning to Australia? *",
      required: true,
      options: [
        { value: "lessThanThreeMonths", label: "Less than 3 months" },
        { value: "MoreThanThreeMonths", label: "more than 3 months but less than 12 months" },
        { value: "lessThanTwelveMonths", label: "12 months or more" },
        
      ],
    },
  ],
},
isMainPurposeHoliday:{
    condition: (formData) => formData.durationBeforeReturningToAu === "lessThanThreeMonths",
  fields: [
    {
      type: "radio",
      name: "isMainPurposeHoliday",
      label: "Is your main purpose in travelling overseas to have a holiday? *",
      required: true,
      options: [
        {value:"yes", label: "Yes"},
        {value:"no", label: "No"},
      ],
    },
  ],
},
  spendTimeInOverseas: {
    condition: (formData) => (formData.birthCountry==="australia"&& formData.homeCountry==='australia') || ((formData.homeCountry === "other"||formData.homeCountry==='none') && formData.birthCountry==="australia" && ['citizenship', 'permanentResidency','visaUnlimited'].includes(formData.whyAllowedInAustralia)),
    fields: [
      {
        type: "radio",
        name: "spendTimeInOverseas",
        label:
          "Do you plan to spend most of your time overseas based in any one place? *",
        required: true,
        options: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
      },
    ],
  },
  outsideAustraliaDuration: {
    condition: (formData) => formData.spendTimeInOverseas === "yes",
    fields: [
      {
        type: "radio",
        name: "outsideAustraliaDuration",
        label:
          "How long do you plan to be based in that place while outside Australia? *",
        required: true,
        options: [
          { value: "lessThanTwoYears", label: "Less than 2 years" },
          { value: "twoToFiveYears", label: "2 to 5 years" },
          { value: "moreThanFiveYears", label: "More than 5 years" },
          { value: "dontKnow", label: "Don't know" },
        ],
      },
    ],
  },
  accommodationType: {
    condition: (formData) =>
      formData.outsideAustraliaDuration === "twoToFiveYears" ||
      formData.outsideAustraliaDuration === "moreThanFiveYears",
    fields: [
      {
        type: "radio",
        name: "accommodationType",
        label:
          "What accommodation do you expect to occupy most of the time that you are in that place? *",
        required: true,
        options: [
          { value: "shortTerm", label: "Short term (hotel, hostel, etc.)" },
          { value: "stayWithFriends", label: "Stay with friends, relatives" },
          { value: "employerProvided", label: "Employer provided or campus" },
          {
            value: "rentedDwelling",
            label: "Rented dwelling (house, flat, etc.)",
          },
          { value: "ownedDwelling", label: "Owned dwelling" },
          { value: "other", label: "Other (includes don't know)" },
          { value: "multiple", label: "More than one of the above" },
        ],
      },
    ],
  },
  isDependantChild: {
    condition: (formData) => !['','shortTerm','other','multiple'].includes(formData.accommodationType),
      fields: [
      {
        type: "radio",
        name: "isDependantChild",
        label:
          "Are you a dependent child? *",
        required: true,
        options: [
         {value: "yes", label: "Yes"},
         {value: "no", label: "No"}
        ],
      },
    ],
  },
  travellingWithParents: {
    condition: (formData) => formData.isDependantChild === "yes",
      fields: [
      {
        type: "radio",
        name: "travellingWithParents",
        label:
          "Are you travelling with or joining your parent/s or guardian/s overseas? *",
        required: true,
        options: [
         {value: "yes", label: "Yes"},
         {value: "no", label: "No"}
        ],
      },
    ],
  },
 travellingWithFamily: {
  condition: (formData) => formData.isDependantChild === "no",
  fields: [
    {
      type: "radio",
      name: "travellingWithFamily",
      label: "Are you travelling with or joining family members (e.g spouse, dependent children) overseas? *",
      required: true,
      options: [
        { value: "allFamily", label: "All family members" },
        { value: "someFamily", label: "Some family members" },
        { value: "noFamily", label: "No family members" },
        { value: "noImmediateFamily", label: "I don't have immediate family members" }
      ],
    },
  ],
},
  returnToAuFourTimes: {
    condition: (formData) => formData.travellingWithParents === "yes"|| (formData.travellingWithFamily === "allFamily" && formData.travellingWithFamily === ""),
      fields: [
      {
        type: "radio",
        name: "returnToAuFourTimes",
        label:
          "Do you plan to return to Australia more than four times every year? *",
        required: true,
        options: [
         {value: "yes", label: "Yes"},
         {value: "no", label: "No"}
        ],
      },
    ],
  },
 plansInAu: {
  condition: (formData) => formData.returnToAuFourTimes === "no"||(formData.travellingWithFamily !== "allFamily" && formData.travellingWithFamily === ""),
  fields: [
    {
      type: "radio",
      name: "plansInAu",
      label: "What are your plans for your Australian home while you are based overseas? *",
      required: true,
      options: [
        { value: "leaveVacant", label: "Leave vacant until I return" },
        { value: "familyOccupy", label: "Friends or family to occupy until I return" },
        { value: "rentOut", label: "Rent out until I return" },
        { value: "retainInvestment", label: "Retain as an investment (do not intend to move back in)" },
        { value: "sellAsap", label: "Sell as soon as possible (or already sold)" },
        { value: "noResidence", label: "Do / did not own a residence in Australia" }
      ],
    },
  ],
},
frequencyOfAuVisits: {
  condition: (formData) => formData.plansInAu !== "",
  fields: [
    {
      type: "radio",
      name: "frequencyOfAuVisits",
      label: "How often do you expect to visit Australia while you are based overseas? *",
      required: true,
      options: [
        { value: "everyThreeMonths", label: "At least every 3 months" },
        { value: "threeToSixMonths", label: "At 3 to 6 month intervals" },
        { value: "oncePerYear", label: "Once per year" },
        { value: "lessThanOncePerYear", label: "Less than once per year" },
        { value: "never", label: "Never" }
      ],
    },
  ],
}

};


const DeterminationResidencyCalculator = () => {
  const [formData, setFormData] = useState({
    under16: "",
    cssOrPss: "",
    isAuResident: "",
    isTemporaryResident: "",
    isEmigrating: "",
    birthCountry: "",
    homeCountry: "",
    whyAllowedInAustralia:"",
    spendTimeInOverseas: "",
    outsideAustraliaDuration: "",
    accommodationType: "",
    isDependantChild: "",
    travellingWithParents:"",
    returnToAuFourTimes:"",
    plansInAu:"",
    frequencyOfAuVisits:"",
    durationBeforeReturningToAu:"",
    isMainPurposeHoliday:"",

  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) || 0 : value,
    }));
  };

  const renderField = (field) => {
    if (field.condition && !field.condition(formData)) return null;

    switch (field.type) {
      case "select":
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <select
              id={field.name}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            >
              {field.options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        );

      case "radio":
        return (
          <div key={field.name} className="form-group">
            <label>
              {typeof field.label === "function"
                ? field.label(formData)
                : field.label}
            </label>
            {field.subLabel && (
              <ul className="sub-label">
                {field.subLabel.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ul>
            )}
            <div className="radio-group">
              {field.options.map((opt) => (
                <div key={opt.value} className="radio-option">
                  <input
                    type="radio"
                    id={`${field.name}-${opt.value}`}
                    name={field.name}
                    value={opt.value}
                    checked={formData[field.name] === opt.value}
                    onChange={handleChange}
                    required={field.required}
                  />
                  <label htmlFor={`${field.name}-${opt.value}`}>
                    {opt.label}
                  </label>
                </div>
              ))}
            </div>
            {field.tooltip && <div className="tooltip">{field.tooltip}</div>}
          </div>
        );

      case "currency":
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <div className="input-with-prefix">
              <span className="currency-symbol">{field.prefix}</span>
              <input
                type="number"
                id={field.name}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                step="0.01"
              />
            </div>
          </div>
        );

      case "number":
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <div className="input-with-suffix">
              <input
                type="number"
                id={field.name}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
              />
              {field.suffix && <span className="unit">{field.suffix}</span>}
            </div>
          </div>
        );

      case "checkboxGroup":
        return (
          <div key={field.name} className="form-group">
            <label>{field.label}</label>
            <div className="checkbox-group">
              {field.options.map((opt) => (
                <div key={opt.value} className="checkbox-option">
                  <input
                    type="checkbox"
                    id={`${field.name}-${opt.value}`}
                    name={field.name}
                    value={opt.value}
                    checked={formData[field.name]?.includes(opt.value)}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prev) => {
                        // Handle 'None of the above' option
                        if (value === "none") {
                          // Assuming '7' is 'None of the above'
                          return {
                            ...prev,
                            [field.name]: e.target.checked ? ["none"] : [],
                          };
                        }

                        // Handle other options
                        const currentValues = prev[field.name] || [];
                        if (e.target.checked) {
                          // Remove 'None of the above' if it was previously selected
                          const newValues = currentValues.filter(
                            (v) => v !== "none"
                          );
                          return {
                            ...prev,
                            [field.name]: [...newValues, value],
                          };
                        } else {
                          return {
                            ...prev,
                            [field.name]: currentValues.filter(
                              (v) => v !== value
                            ),
                          };
                        }
                      });
                    }}
                    required={
                      field.required && formData[field.name]?.length === 0
                    }
                  />
                  <label htmlFor={`${field.name}-${opt.value}`}>
                    {opt.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        );
      default:
        <></>;
      // Add other field types as needed
    }
  };

  const renderSection = (section, sectionKey) => {
    if (section.condition && !section.condition(formData)) return null;

    return (
      <div key={sectionKey} className="form-section">
        <h2>{section.title}</h2>
        {section.fields.map((field) => renderField(field))}
      </div>
    );
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const payload = {
        target_underage: formData.under16 === "yes" ? "yes" : "no",
        target_spouse_parent: formData.cssOrPss === "yes" ? "yes" : "no",
        target_resident_before_leaving: formData.isAuResident === "yes" ? "yes" : "no",
        target_temp_aust_resident: formData.isTemporaryResident === "yes" ? "yes" : "no",
        target_resident_emigrating: formData.isEmigrating === "yes" ? "yes" : "no",
        target_born_where: formData.birthCountry === "australia" ? "australia" : "other",
        target_home_country: formData.homeCountry === "australia" ? "australia" : 
                            formData.homeCountry === "other" ? "other" : "none",
        target_allowed_in_australia: formData.whyAllowedInAustralia === "citizenship" ? "citizen" :
                                    formData.whyAllowedInAustralia === "permanentResidency" ? "permanent" :
                                    formData.whyAllowedInAustralia === "visaUnlimited" ? "unlimited" :
                                    formData.whyAllowedInAustralia === "visaLimited" ? "limited" : "notauthorized",
        target_remain_overseas: formData.durationBeforeReturningToAu === "lessThanThreeMonths" ? "lessthanthree" :
                               formData.durationBeforeReturningToAu === "MoreThanThreeMonths" ? "morethanthree" : "morethantwelve",
        target_travelling_purpose: formData.isMainPurposeHoliday === "yes" ? "yes" : "no",
        target_dependent_child: formData.isDependantChild === "yes" ? "yes" : "no",
        target_travelling_with_family: formData.travellingWithFamily === "allFamily" ? "all" :
                                      formData.travellingWithFamily === "someFamily" ? "some" :
                                      formData.travellingWithFamily === "noFamily" ? "no" : "none",
        target_home_in_australia: formData.plansInAu === "leaveVacant" || 
                                 formData.plansInAu === "familyOccupy" || 
                                 formData.plansInAu === "rentOut" ? "yes" : "no",
        target_personal_belongings_stored: "yes", // Assuming this is always yes or you can map it from formData
        target_travelling_with_parents: formData.travellingWithParents === "yes" ? "yes" : "no",
        target_overseas_base: formData.spendTimeInOverseas === "yes" ? "yes" : "no",
        target_spend_two_years: formData.outsideAustraliaDuration === "lessThanTwoYears" ? "no" : "yes",
        target_plan_to_be_based: formData.outsideAustraliaDuration === "twoToFiveYears" ? "two" :
                                formData.outsideAustraliaDuration === "moreThanFiveYears" ? "five" : "dontknow",
        target_accommodation_to_occupy: formData.accommodationType === "shortTerm" ? "short" :
                                       formData.accommodationType === "stayWithFriends" ? "friends" :
                                       formData.accommodationType === "employerProvided" ? "employer" :
                                       formData.accommodationType === "rentedDwelling" ? "rented" :
                                       formData.accommodationType === "ownedDwelling" ? "owned" : "other",
        target_dependent_child_path_c: formData.isDependantChild === "yes" ? "yes" : "no",
        target_travelling_with_parents_path_c: formData.travellingWithParents === "yes" ? "yes" : "no",
        target_travelling_with_family_path_c_alt: formData.travellingWithFamily === "allFamily" ? "yes" : "no",
        target_return_to_australia_decision: formData.returnToAuFourTimes === "yes" ? "yes" : "no",
        target_plans_for_aust_home_decision: formData.plansInAu === "leaveVacant" ? "vacant" :
                                           formData.plansInAu === "familyOccupy" ? "family" :
                                           formData.plansInAu === "rentOut" ? "rent" :
                                           formData.plansInAu === "retainInvestment" ? "retain" :
                                           formData.plansInAu === "sellAsap" ? "sell" : "noresidence",
        target_expect_to_visit_decision: formData.frequencyOfAuVisits === "everyThreeMonths" ? "threemonths" :
                                        formData.frequencyOfAuVisits === "threeToSixMonths" ? "sixmonths" :
                                        formData.frequencyOfAuVisits === "oncePerYear" ? "onceyear" :
                                        formData.frequencyOfAuVisits === "lessThanOncePerYear" ? "lessthanonce" : "never"
      };

      const response = await axios.post(
        `${API_BASE_URL}/ato_calculator/calculate_residency_leaving_aust`,
        payload
      );
      setResult(response?.data?.final_result_status);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "An error occurred while processing your request"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h1>Determination of residency status – leaving Australia </h1>
      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit}>
        {Object.entries(formSchema).map(([key, section]) =>
          renderSection(section, key)
        )}
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Calculating..." : "Calculate"}
        </button>
      </form>

      {loading && <div className="loader"></div>}

      {result && (
        <div className="result-container">
          <h2>Results</h2>
          <div className="result-content">
            <p>
              <strong>Residency Status:</strong> {result}
            </p>
            {result.explanation &&
              {
                /* <p><strong>Explanation:</strong> {result.explanation}</p> */
              }}
            {/* {result.lodgment_required !== undefined && (
              <p><strong>Lodgment Required:</strong> {result.lodgment_required ? 'Yes' : 'No'}</p>
            )}
            {result.lodgment_explanation && (
              <p><strong>Lodgment Details:</strong> {result.lodgment_explanation}</p>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeterminationResidencyCalculator;
